const WorkWithUsSection = () => {
    return (
        <div id="work-with-us">
            <div className="relative min-h-[400px]">
                <div className="text-center">
                    <h2 className="text-3xl sm:text-5xl lg:text-6xl mt-10 lg:mt-20 tracking-wide">
                        Work With{" "}
                        <span className="bg-gradient-to-r from-cyan-500 to-cyan-600 text-transparent bg-clip-text">
                            Us
                        </span>
                    </h2>
                </div>
                <div className="flex flex-wrap mt-10 lg:mt-20">
                    <p className="text-justify">
                        At SalePersona, we provide high-quality company postal and email lists, advanced data services, and targeted marketing solutions to help businesses connect with the right prospects.
                        Our cost-effective strategies ensure precision and reliability, empowering clients to reach their audience seamlessly. With our fast response times and expert support, you can execute your marketing campaigns efficiently and drive real growth.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default WorkWithUsSection;
